import { MessageInterface } from "../Message/Message.Interface";
import { UserInterface } from "../User/User.Interface";

export enum TranscriptStatus {
  Loading,
  Error,
  InvalidUserId,
  InvalidUserPermissions,
  Expired,
  Valid
}
export interface TranscriptPayload {
  user?: UserInterface;
  status: TranscriptStatus;
  messages?: MessageInterface[];
  expiresAt?: Date;
}
